import { useState } from "react";
// Chakra imports
import {
  Box,
  useColorModeValue,
  SimpleGrid,
  Icon,
  Text,
  Flex,
} from "@chakra-ui/react";

// Custom components
import CardInfoClient from "./components/CardBasicInfoClients";
import Card from "components/card/Card";
import { RiCouponFill } from "react-icons/ri";
import { IoIosSave } from "react-icons/io";

// Assets
import { TerminaisTable } from "./components/TerminaisTable";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { MdAttachMoney, MdSell } from "react-icons/md";
import { useLocation } from "react-router-dom";
import NumerariosCardsCliente from "./components/NumerarioCard";
import { BackupTable } from "./components/BackupCard";
import { useClients } from "hooks/ClientsHook";
import { useQuery } from "react-query";

export default function InfoCliente() {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("#ffff", "#111c44");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const parametro = queryParams.get("idClient");
  const isMaster = localStorage.getItem("master") === "true";
  const [totalNumerarios, setTotalNumerarios] = useState<number>(0);

  const { findInfosClientsById } = useClients();
  const { data, isLoading, error } = useQuery(
    ["findInfosClientsById", parametro],
    () => findInfosClientsById(Number(parametro)),
    {
      retry: false,
    }
  );

  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      {error ? (
        <Flex
          align="center"
          justify="center"
          direction="column"
          p={8}
          mb="20px"
          bg={boxBg}
          borderRadius="20px"
        >
          <Text color="red.500" fontSize="xl" fontWeight="bold" mb={2}>
            {String(error)}
          </Text>
        </Flex>
      ) : (
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 4, "2xl": 4 }}
          gap="20px"
          mb="20px"
        >
          {isMaster && (
            <>
              <MiniStatistics
                loading={isLoading}
                startContent={
                  <IconBox
                    w="56px"
                    h="56px"
                    bg={boxBg}
                    icon={
                      <Icon w="32px" h="32px" as={MdSell} color={brandColor} />
                    }
                  />
                }
                growth={data?.CARDS?.PORCENTAGEM_TICKET_MEDIO}
                name="Ticket médio"
                value={
                  data?.CARDS?.TICKET_MEDIO?.toLocaleString("pt-br", {
                    currency: "BRL",
                  }) || "0"
                }
              />

              <MiniStatistics
                loading={isLoading}
                startContent={
                  <IconBox
                    w="56px"
                    h="56px"
                    bg={boxBg}
                    icon={
                      <Icon
                        w="32px"
                        h="32px"
                        as={MdAttachMoney}
                        color={brandColor}
                      />
                    }
                  />
                }
                growth={data?.CARDS?.PORCENTAGEM_VENDAS}
                name="Valor em vendas (R$)"
                value={totalNumerarios.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              />
            </>
          )}

          <MiniStatistics
            loading={isLoading}
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon w="32px" h="32px" as={IoIosSave} color={brandColor} />
                }
              />
            }
            name="Data do último BKP"
            value={data?.CARDS?.DATA_BKP || "N/A"}
          />

          <MiniStatistics
            loading={isLoading}
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon
                    w="32px"
                    h="32px"
                    as={RiCouponFill}
                    color={brandColor}
                  />
                }
              />
            }
            name="Cupons pendentes"
            value={data?.CARDS?.CUPONS_PENDENTES?.toString() || "0"}
          />
        </SimpleGrid>
      )}

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap="20px" mb="20px">
        <CardInfoClient id={parseFloat(parametro)} />
        {isMaster && (
          <NumerariosCardsCliente
            total={(value: number) => setTotalNumerarios(value)}
            id={parseFloat(parametro)}
          />
        )}
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} gap="20px" mb="20px">
        <Card maxH="60vh" px="0px">
          <TerminaisTable id={parseFloat(parametro)} />
        </Card>

        <Card maxH="60vh" px="0px">
          <BackupTable id={parseFloat(parametro)} />
        </Card>
      </SimpleGrid>
    </Box>
  );
}
